import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import logger from "./logger";

const URL_SYNC = "url_sync";
const USER_UNAUTHENTICATED = "user_unauthenticated";

interface UrlSyncMessage {
  name: string;
  type: typeof URL_SYNC;
  origin: string;
  pathname: string;
  search: string;
}

export const sendUserUnauthenticatedMessage = () => {
  logger.debug("Sending USER_UNAUTHENTICATED from data-explorer");
  window.parent.postMessage(USER_UNAUTHENTICATED, "*");
};

export const useSyncUrl = () => {
  const location = useLocation();

  useEffect(() => {
    const message: UrlSyncMessage = {
      name: "data-explorer",
      type: URL_SYNC,
      origin: window.location.origin,
      pathname: location.pathname,
      search: location.search,
    };

    window.parent.postMessage(message, "*");
  }, [location.pathname, location.search]);
};
